import PropTypes from 'prop-types';
import React from 'react';
import LinkIcon from './LinkIcon';

const MAX_NR_OF_ITEMS = 5;

const GenericCallWidgetBody = ({ items = [], darkMode }) => (
    <div className="gap-x-2">
        {items
            .slice(0, MAX_NR_OF_ITEMS)
            .map(
                (
                    {
                        primaryLabel,
                        secondaryLabel,
                        actionUrl,
                        actionIcon,
                        actionCallback,
                    },
                    index,
                ) => (
                    <LinkIcon
                        key={index}
                        primaryLabel={primaryLabel}
                        secondaryLabel={secondaryLabel}
                        actionUrl={actionUrl}
                        actionIcon={actionIcon}
                        actionCallback={actionCallback}
                        darkMode={darkMode}
                    />
                ),
            )}
    </div>
);

GenericCallWidgetBody.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            primaryLabel: PropTypes.string,
            secondaryLabel: PropTypes.string,
            actionUrl: PropTypes.string,
            actionIcon: PropTypes.node,
            actionCallback: PropTypes.func,
        }),
    ),
    darkMode: PropTypes.bool.isRequired,
};

export default React.memo(GenericCallWidgetBody);
